import { defineComponent as _defineComponent } from 'vue'
import {Configuration} from "@/app/helpers/QueryParams";
import { ref, computed, onMounted } from "vue"
import Option from "@/app/models/Option";
import InfoButton from "@/components/InfoButton.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'EditionOptionContainer',
  props: {
    config: null,
    optionType: null,
    title: null,
    disclaimer: null,
    optionLimit: null
  },
  setup(__props: any) {

const props = __props as {
  config: Configuration;
  optionType: string;
  title: string;
  disclaimer?: string;
  optionLimit?: number;
};



const readMore = ref(false)
const heightLimit = ref('')

const options = computed(() => {
  return props.config.edition?.options
    .filter((option) => option.type === props.optionType)
    .sort((opt1: Option, opt2: Option) => {
      if (opt1.mandatory && opt2.mandatory) {
        return opt1.name.toLowerCase().localeCompare(opt2.name.toLowerCase())
      }
      if (opt1.mandatory) {
        return -1
      }
      if (opt2.mandatory) {
        return 1
      }
      return opt1.name.toLowerCase().localeCompare(opt2.name.toLowerCase())
    }) || []
})

function setHeightLimit() {
  const minHeight = props.optionLimit ? `${24 * props.optionLimit }px` : `${24 * options.value.length }px`
  const maxHeight = `${24 * options.value.length }px`

  heightLimit.value = props.optionLimit && !readMore.value ? minHeight : maxHeight;
}

function onClickReadMore() {
  readMore.value = !readMore.value

  setHeightLimit()
}

onMounted(() =>{
  if (props.optionLimit) {
    setHeightLimit()
  }
})


return { __sfc: true,props, readMore, heightLimit, options, setHeightLimit, onClickReadMore, InfoButton }
}

})